import { navigationEvents } from './navigationEvents';

// Store the current path before redirecting to login
const REDIRECT_PATH_KEY = 'kamco_redirect_path';

export const authErrorHandler = {
  // Handle 401 errors by clearing auth and redirecting to login
  handle401Error(currentPath?: string) {
    console.log('Handling 401 error - unauthorized access');
    
    // Store current path for redirect after login (if not already on login/register)
    if (currentPath && !currentPath.includes('/login') && !currentPath.includes('/register')) {
      sessionStorage.setItem(REDIRECT_PATH_KEY, currentPath);
    }
    
    // Clear any auth-related storage
    this.clearAuthState();
    
    // Navigate to login
    navigationEvents.navigate('/login', { replace: true });
  },
  
  // Clear all authentication state
  clearAuthState() {
    // Clear any tokens from localStorage/sessionStorage
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    
    // Clear any other auth-related data
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    
    // Note: The actual auth context state will be cleared by the logout method
  },
  
  // Get the redirect path after successful login
  getRedirectPath(): string | null {
    const path = sessionStorage.getItem(REDIRECT_PATH_KEY);
    if (path) {
      sessionStorage.removeItem(REDIRECT_PATH_KEY);
    }
    return path;
  }
};